//LIBRERIE
import React from "react";
import { useTranslation } from "react-i18next";
import Carousel from 'react-bootstrap/Carousel';

const AboutUsMain: React.FC = () => {

    const { t } = useTranslation();

    const team = [
        {
            name: "Lucia Mariotti",
            role: t('aboutUsPage.section2.member1.role'),
            description: t('aboutUsPage.section2.member1.description'),
            image: "assets/images/altrePag/agenti/lucia.jpg",
        },
        {
            name: "Edoardo Finucci",
            role: t('aboutUsPage.section2.member2.role'),
            description: t('aboutUsPage.section2.member2.description'),
            image: "assets/images/altrePag/agenti/edoardo.jpg",
        }
    ];

    return (
        <>
            <section className="mb-4 mb-lg-5">
                <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.section1.text1') as string }}></p>
                <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.section1.text2') as string }}></p>
                <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.section1.text3') as string }}></p>
                <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.section1.text4') as string }}></p>
                <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.section1.text5') as string }}></p>
            </section>

            <section className="mb-4 mb-lg-5">
                <h2 className="mb-4 mb-lg-5">{t('aboutUsPage.section2.title')}</h2>
                <div className="row">
                    {team.map((agent, index) => (
                        <div className="col-12 mb-4 mb-lg-0 agent" key={index}>
                            <div className="row justify-content-around align-items-center position-relative">
                                <div className={`col-12 col-lg-4 col-xl-3 ${index % 2 ? "order-lg-1" : "order-lg-2"}`}>
                                    <div className="text-center agent-image">
                                        <img className="img-fluid" src={agent.image} alt={agent.name} />
                                        <h3>{agent.name}</h3>
                                    </div>
                                </div>
                                <div className={`col-12 col-sm-10 col-lg col-xl-8 ${index % 2 ? "order-lg-2" : "order-lg-1"}`}>
                                    <div className="p-3 pt-5 pt-lg-3 p-xl-5 agent-info">
                                        <h4>{agent.role}</h4>
                                        <p className="m-0" dangerouslySetInnerHTML={{ __html: t(agent.description) as string }}></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            <section className="mb-4 mb-lg-5 sedi">
                <h2 className="mb-4 mb-lg-5">{t('aboutUsPage.section3.title')}</h2>
                <div className="row align-items-center justify-content-center">
                    <div className="col-12 col-lg-7 col-xl-8">
                        <div className="mb-4 mb-xl-5">
                            <h3>{t('aboutUsPage.section3.site1')}</h3>
                            <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.section3.text1') as string }}></p>
                        </div>
                        <div>
                            <h3>{t('aboutUsPage.section3.site2')}</h3>
                            <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.section3.text2') as string }}></p>
                        </div>
                    </div>
                    <div className="col-12 col-md-9 col-lg-5 col-xl-4">
                        <Carousel controls={false} indicators={false} interval={4000} pause={false}> 
                            <Carousel.Item>
                                <img className="img-fluid border" src="/assets/images/altrePag/murlo1.jpg" alt={t('aboutUsPage.section3.imageAlt') as string} />
                                <Carousel.Caption>
                                    <figcaption>Murlo</figcaption>
                                </Carousel.Caption>
                            </Carousel.Item>
                            <Carousel.Item>
                                <img className="img-fluid border" src="/assets/images/altrePag/siena1.jpg" alt={t('aboutUsPage.section3.imageAlt1') as string} />
                                <Carousel.Caption>
                                    <figcaption>Siena</figcaption>
                                </Carousel.Caption>
                            </Carousel.Item>
                            <Carousel.Item>
                                <img className="img-fluid border" src="/assets/images/altrePag/siena2.jpg" alt={t('aboutUsPage.section3.imageAlt1') as string} />
                                <Carousel.Caption>
                                    <figcaption>Siena</figcaption>
                                </Carousel.Caption>
                            </Carousel.Item>
                        </Carousel>
                    </div>
                </div>
            </section>

        </>
    )
};
export default AboutUsMain;